import moment from 'moment'
import React from 'react'

//* utils
import { ASSETS } from '../../../../../../constants/assets'
import { ModuleNames } from '../../../../../../constants/componentNames.constants'
import { OPTIONS } from '../../../../../../constants/dateOptions'
import { MicrocopySet } from '../../../../../../models/others/microcopy'
import { findTarget } from '../../../../../../utils/microcopy.utils'

//* components
import ContentBlock from '../../../../../global/contentBlock'
import Tiles from '../../../../../global/tiles'
import ListingItem from '../../listingItem'

export const getTeaserMarkup = (twoTeasers: any, node_locale: string) => {
  return (
    twoTeasers?.map((teaser: any, index: number) => {
      const metaInformation = teaser.metaInformation ? teaser.metaInformation[0] : []
      const date = teaser.date ? new Date(teaser.date) : ''
      let formattedDate = date && moment(date).utc().format('D MMMM YYYY')
      formattedDate = new Date(formattedDate).toLocaleDateString(node_locale, OPTIONS)

      return (
        <ListingItem
          key={`ListItem--${teaser.slug || ''}-${index}`}
          {...{
            listingTitle: teaser.title || teaser.h1Title || '',
            listingSlug: teaser.slug || '',
            listingUrl: teaser.url1 || '',
            listingType: teaser.articleType || teaser.category?.title,
            listingPublication: metaInformation.customerName || '',
            formattedDate,
          }}
        />
      )
    }) || []
  )
}

export const getSocialMediaBoilerPlate = (entries: any) => {
  if (!entries?.length) return []
  let socialMediaBoilerPlate = []

  for (let i = 0; i < entries.length; i++) {
    if (entries[i].__typename === ModuleNames.GLOBAL_CONTENT_BLOCK) {
      socialMediaBoilerPlate.push(
        <ContentBlock key={`socialMediaBoilerPlate-${i}`} data={entries[i]} />
      )
    } else if (entries[i].__typename === ModuleNames.TILES) {
      socialMediaBoilerPlate.push(<Tiles key={`socialMediaBoilerPlate-${i}`} data={entries[i]} />)
    }
  }

  return socialMediaBoilerPlate
}

export const getHeroProps = (
  date: string,
  microcopy: MicrocopySet,
  node_locale: string,
  title: string
) => {
  let formattedDate: any
  if (date) {
    formattedDate = moment(new Date(date)).utc().format('MMMM D, YYYY')
    formattedDate = new Date(formattedDate).toLocaleDateString(node_locale, OPTIONS)
  }

  const eyebrow = Array.isArray(microcopy?.values)
    ? findTarget('newsroom.article.Eyebrow.text', microcopy.values)
    : ''

  const heroProps = {
    headline: title,
    subheadline: {
      subheadline: formattedDate || '',
    },
    eyebrow: eyebrow,
    heroTheme: 'light',
    backgroundAsset: {
      image: {
        file: {
          url: ASSETS.HERO_NEWSROOM,
        },
      },
    },
  }

  return heroProps
}
